export default __webpack_public_path__ + "static/media/doc_pdf.18a53b29.svg";